const map = {
  'share/1': 'http://bit.ly/2pZZGVv',
  'share/2': 'http://bit.ly/2pZZOUZ',
  'share/3': 'http://bit.ly/2pYjFnB',
  'share/4': 'http://bit.ly/2pUYpPr',
  'share/5': 'http://bit.ly/2pW5ijl',
  'share/6': 'http://bit.ly/2pZZR37',
  'share/7': 'http://bit.ly/2pZZFkp',
  'share/8': 'http://bit.ly/2pYjFE7',
  'share/9': 'http://bit.ly/2pZ4FFM',
  'share/10': 'http://bit.ly/2pWGiZp',
  'share/11': 'http://bit.ly/2pZZQw5',
  'share/12': 'http://bit.ly/2pVduAm',
  'share/13': 'http://bit.ly/2pVuarC',
  'share/14': 'http://bit.ly/2pZZKEJ',
  'share/15': 'http://bit.ly/2q5jS8B',
  'share/16': 'http://bit.ly/2pXCaIA',
  'share/17': 'http://bit.ly/2pTy3gO',
  'share/18': 'http://bit.ly/2pYOxE8',
  'share/19': 'http://bit.ly/2pZZMfP',
  'share/20': 'http://bit.ly/2pYOxUE',
  'share/21': 'http://bit.ly/2pZZDZP',
  'share/22': 'http://bit.ly/2pZ4FWi',
  'share/23': 'http://bit.ly/2pZZHZz',
  'share/24': 'http://bit.ly/2pW5izR',
  'share/25': 'http://bit.ly/2pZZLsh',
  'share/26': 'http://bit.ly/2pZZOnX',
  'share/27': 'http://bit.ly/2pYLkob',
  'share/28': 'http://bit.ly/2pZZFRr',
  'share/29': 'http://bit.ly/2pZZNQV',
  'share/30': 'http://bit.ly/2pZZPbv',
  'share/31': 'http://bit.ly/2pXGsQ9',
  'share/32': 'http://bit.ly/2pZcpYu',
  'share/33': 'http://bit.ly/2pZZHsx',
  'share/34': 'http://bit.ly/2pZZPIx',
  'share/35': 'http://bit.ly/2pWYh1K',
  'share/36': 'http://bit.ly/2pUYqCZ',
  'share/37': 'http://bit.ly/2pZZJ3D',
  'share/38': 'http://bit.ly/2q0bKWx',
  'share/39': 'http://bit.ly/2pZZENn',
  'share/40': 'http://bit.ly/2pXELm1',
  'share/41': 'http://bit.ly/2pVMFfw',
  'share/42': 'http://bit.ly/2pZcpHY',
  'share/43': 'http://bit.ly/2pZZN3n',
  'share/44': 'http://bit.ly/2pZZDJj',
  'share/45': 'http://bit.ly/2pZZLbL',
  'share/46': 'http://bit.ly/2pWTo99',
  'share/47': 'http://bit.ly/2pWTopF',
  'share/48': 'http://bit.ly/2pZZK7H',
  'share/49': 'http://bit.ly/2pZZMMR',
  'share/50': 'http://bit.ly/2pZZIN7',
  'share/51': 'http://bit.ly/2pZaKlQ',
  'share/52': 'http://bit.ly/2pVMIIe',
  'share/53': 'http://bit.ly/2pZB5A8',
  'share/54': 'http://bit.ly/2pVdyjA',
  'share/55': 'http://bit.ly/2pYjXuH',
  'share/56': 'http://bit.ly/2pXGw2l',
  'share/57': 'http://bit.ly/2pYjZ5N',
  'share/58': 'http://bit.ly/2pYjY1J',
  'share/59': 'http://bit.ly/2pZmDYY',
  'share/60': 'http://bit.ly/2pYjTuX',
  'share/61': 'http://bit.ly/2pYjOr9',
  'share/62': 'http://bit.ly/2pVMIYK',
  'share/63': 'http://bit.ly/2pYLonV',
  'share/64': 'http://bit.ly/2pYjUPx',
  'share/65': 'http://bit.ly/2pYjPvd',
  'share/66': 'http://bit.ly/2pYjWqD',
  'share/67': 'http://bit.ly/2pXi3u5',
  'share/68': 'http://bit.ly/2pYjUiv',
  'share/69': 'http://bit.ly/2pWRd5p',
  'share/70': 'http://bit.ly/2pYjWXF',
  'share/71': 'http://bit.ly/2pYjR6j',
  'share/72': 'http://bit.ly/2pWGmID',
  'share/73': 'http://bit.ly/2pYktsD',
  'share/74': 'http://bit.ly/2q0bOFL',
  'share/75': 'http://bit.ly/2pZaK5k',
  'share/76': 'http://bit.ly/2pWRdlV',
  'share/77': 'http://bit.ly/2pZcA66',
  'share/78': 'http://bit.ly/2pYjZCP',
  'share/79': 'http://bit.ly/2pYjQzh',
  'share/80': 'http://bit.ly/2pYjNn5',
  'share/81': 'http://bit.ly/2pYjVmz',
  'share/82': 'http://bit.ly/2pZZYM5',
  'share/83': 'http://bit.ly/2pZmDIs',
  'share/84': 'http://bit.ly/2pYjRmP',
  'share/85': 'http://bit.ly/2pUYtyF',
  'share/86': 'http://bit.ly/2pYjNDB',
  'share/87': 'http://bit.ly/2AftseA',
  'share/88': 'http://bit.ly/2pYjQ2f',
  'share/89': 'http://bit.ly/2pYOBUo',
  'share/90': 'http://bit.ly/2pYjOYb',
  'share/91': 'http://bit.ly/2pXEPCh',
  'share/92': 'http://bit.ly/2pWYkus',
  'share/93': 'http://bit.ly/2pYjVD5',
  'share/94': 'http://bit.ly/2pTy6t0',
  'share/95': 'http://bit.ly/2pYk09R',
  'share/96': 'http://bit.ly/2pXCeIk',
  'share/97': 'http://bit.ly/2pYjYif',
  'share/98': 'http://bit.ly/2pYjSan',
  'share/99': 'http://bit.ly/2pXi3KB',
  'share/100': 'http://bit.ly/2pWYkKY',
};

export default map;
